export default {
  fullname: '香港法律资讯中心',
  subheading: '免费提供有关香港法律的资讯网页',
  lawtech: '由香港大学法律学院法律与科技研究中心设立',
  news_1_title: "欢迎使用 HKLII 的升级版网站",
  news_1_intro: "香港法律资讯中心 (HKLII)的升级版网站终于登场。如希望了解其新功能，请查看{0}。本站的新功能和改进之处包括：",
  news_1_content: [
    "Y你的宝贵意见有助我们精益求精, 请花一分钟时间在网站右下角的{0}内评分，或填写{1}。我们亦藉此机会感谢各位 Beta 测试的参与者，你们的评语和建议令 HKLII 变得更为实用。",
    "未来我们仍将勉力前行，务求将人工智慧技术整合到 HKLII 之中，提供免费且便于理解的法律资讯。我们十分感激各界对 HKLII 的捐助，并诚挚邀请您加入捐款者的行列，{0}我们的使命。所有捐款人均会在我们的网站上获得{1}。"
  ],
  news_1_newfeature: [
    "可使用判例引文搜寻判决书",
    "Noteup 现已支援判例引文",
    "扩大了使用通用编号及案件编号搜寻案件的范围",
    "自动整合案件记录及上诉历史",
    "条文定义的连结更加准确",
    "增加了简体中文版的法例资料库",
    "可快速连结至官方法例页面 (e-Legislation)",
    "介面设计会自动适应各种设备(手机、桌上电脑)",
    "判案书及法例的版式更易于阅读"
  ],
  news_1_subhead: [
    "意见及查询",
    "支持智能 HKLII 的发展"
  ],
  news_1_donation: "支持",
  news_1_thankdonor: "铭谢",
  news_2_title: "Hong Kong Company Law Cases (HKCLC) 引述案例编号现已加入 HKLII",
  news_2_content: [
    "我们现在提供 HKCLC 引述案例编号。你将会在判案书左侧「有关此判案书」一栏内的「判例引文」找到相关资讯。你亦能在搜寻栏里输入案例编号 (例: [2022] HKCLC 715) 直接搜寻判案书及有关引述。",
    "HKCLC 是一系列判例汇编，涵盖香港公司法案件和涉及香港公司的海外公司法案件。"
  ],
  news_3_title: "HKLII 迁移通知",
  news_3_content: [
    "从 2023 年 6 月 16 日起，您将能够通过 {0} 訪問 HKLII 的升級版本。现有的地址 v2.hklii.hk 将继续使用。",
    "如果您想访问旧版本的 HKLII，请访问 {0}。",
    "我们感谢您一直以来的支持，请将任何评论或问题发送到我们的{0}。",
  ],
  news_4_title: "HKLII 现已引入 AI 驱动功能",
  news_4_intro: [
    "在过去两年，HKLII 的研发团队致力开发应用人工智能技术的新功能以增加法律研究的效率。我们已将研究成果应用到 HKLII 推出的新功能中。",
    "新增功能标将以 {0} 标签识别。请注意以下功能只适用于英文判决书和搜寻。请访问我们的{1}页面以深入了解各种功能。新功能包括：",
    "我们亦设计了「{0}」，以图像和统计工具帮助用家掌握历年贩毒和人身伤亡案件的数据。",
  ],
  news_4_content: [
    "我们想趁此机会感谢所有参与了 Beta 测试的用家。如果您对新功能有任何疑问或建议，请随时与我们联系。",
    "感谢你使用 HKLII，我们期待为你提供更好的服务。",
  ],
  news_4_newfeature: [
    "智能搜索分类和建议",
    "贩毒及人身伤亡案件的案件资讯",
    "以标签搜寻类似的人身伤亡案件",
    "人身伤亡案件概要",
  ],
  ratingbox: "评分框",
  feedbackfrom: "意见表格",
  feedbackpage: "反馈页面",
  sitetour: "网站导览",
  signoff: "HKLII 团队",
  chi_signoff: "敬启",
  donatecard_title: "请支持我们构建新一代 HKLII",
  donatecard_content: "HKLII 一直致力于让人人可查阅法律。2020年，我们着手升级已有20年历史的网站，令HKLII的接口与时并进，并添加了新功能以改善用户的法律研究体验。尽管疫情肆虐，我们并未停步。接下来，我们仍将勉力前行， 务求在免费提供法律信息的同时开发更智能功能。我们十分感激各界对HKLII的捐助，并诚挚邀请您加入捐款者的行列，{0}我们的使命。我们盼望在未来几年内筹集一百万元，将人工智能技术整合到HKLII之中。",
  falm_intro:"HKLII 免费提供有关香港法律的资讯及参与法律信息自由取用运动。",
  advanced_desc: '指定类别和数据库作针对性搜寻',
  simple_desc: '你可以在此使用搜寻运算符 (AND, NEAR, tax*, <br/> "moral rights", ... 等) 以寻找站内资料, 如: <li>法例章号 (599J)</li><li>判决书 (頸 NEAR 麻痹)</li><li>判例引文 ([2001] 1 HKLRD 1)</li><li>法律概念 (procedural impropriety)</li><li>人物 (Chief Justice AND Andrew Li)</li>',
  announcements: '最新消息',
  news: '最近上载的原讼法庭、上诉法庭及终审法院判案书',
  case_summary:'案件扼要',
  case_summary_desc:'快速查看重点标注。注意此功能暂不支援中文判案书。',
  shortcut_hint:'本部分将在此设备保持打开（或关闭）',
  judgments: '判案书',
  judgments_altlang: '', //'英文判案書'
  legislation: '法例',
  copyright: '版权所有',
  crinfo: '香港法律资讯中心 (HKLII)',
  run_by: '运营',
  manage_by: '运营',
}
